var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_896_4965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5 46.25C81.6164 46.25 93.8539 51.2674 102.962 60.375L108.205 55.1314C97.6995 44.622 83.5967 38.8333 68.5 38.8333C53.4034 38.837 39.3006 44.622 28.7949 55.1314L34.0385 60.375C43.1462 51.2674 55.3837 46.25 68.5 46.25ZM89.53 77.0551C78.1306 65.6557 58.8695 65.6557 47.4701 77.0551L52.7137 82.2987C61.2688 73.7436 75.7313 73.7436 84.2864 82.2987L89.53 77.0551Z",
    fill: "#DA0067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7875 65.8782C82.833 48.9163 54.1713 48.9163 37.2168 65.8782L42.4604 71.1218C56.578 57.0042 80.4263 57.0042 94.5439 71.1218L99.7875 65.8782Z",
    fill: "#DA0067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5007 98.1667C72.5968 98.1667 75.9173 94.8461 75.9173 90.75C75.9173 86.6539 72.5968 83.3333 68.5007 83.3333C64.4045 83.3333 61.084 86.6539 61.084 90.75C61.084 94.8461 64.4045 98.1667 68.5007 98.1667Z",
    fill: "#DA0067"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_896_4965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.6574,
    height: 95.6574,
    fill: "white",
    transform: "translate(0 67.6399) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/internet.c8edddcbf374f0dbaa0d2e81d999c853.svg";
export { ForwardRef as ReactComponent };